import { DataAccessTypeEnum, ShareMetadata } from "../features/ShareContact";
import { BeneficiaryInfo } from "../mislaka_xml_insurence_models";

export interface BizData {
  business_name?: string;
  business_address?: string;
  annual_revenue?: number;
  business_sector?: string;
  biz_id?: string;
}

export interface LastEmploymentData {
  employer_name?: string;  // שם מעסיק
  employer_additional_name?: string;  // שם נוסף למעסיק
  occupation?: string;  // עיסוק/תפקיד
  gross_salary?: number;  // שכר ברוטו
  net_salary?: number;  // שכר נטו
  is_active?: boolean;  // האם העסקה פעילה
}

export interface ResidentialData {
  country_of_birth?: string;
  foreign_resident?: boolean;
  additional_country_resident?: boolean;
  us_citizenship?: boolean;
  residence_country?: string;
}

export interface FormalFamilyRelations {
  is_public_figure?: boolean;
  family_senior_position?: boolean;
  relation_or_position?: string;
  aml_service_refused?: boolean;
}

/** A bank account of the client (backend ContactBankAccount) */
export interface ContactBankAccount {
  id: string; // the same on both spouses for a joint account
  bank_code?: string | null; // BankHandlerCode ("12")
  branch_number?: string | null;
  account_number?: string | null;
  joint?: boolean;
  joint_with_contact_id?: number | null; // the spouse - for a joint account
  is_default?: boolean; // the account forms use (else the first)
}

export interface ContactExtData {
  biz_data?: BizData[];
  last_employment_data?: LastEmploymentData[];
  residential_data?: ResidentialData;
  formal_relations?: FormalFamilyRelations;
  family_data?: BeneficiaryInfo[];
  /** the client's beneficiaries definition (spouse / children / other + percentage) - what every fund should have */
  beneficiaries?: BeneficiaryInfo[];
  /** the client's bank accounts - their own and joint ones (kept on both spouses, the same id) */
  bank_accounts?: ContactBankAccount[];
  identification_time_stamp?: string;  // ISO date string when ID was verified
}

export enum ContactStatus {
    NEW = "NEW",                         // רק נרשם (דף נחיתה, טלפון וכו')
    ENGAGED = "ENGAGED",                 // התחיל מגע אנושי (שיחה/טופס)
    VALIDATED = "VALIDATED",             // נתן פרטים כמו ת"ז
    DATA_FETCHED = "DATA_FETCHED",       // בוצעה שליפת מסלקה
    PAYING_CLIENT = "PAYING_CLIENT",     // ביצע תשלום עבור שירות
    ACTIVE_SUBSCRIPTION = "ACTIVE_SUBSCRIPTION",  // יש לו שירות שוטף
    DORMANT = "DORMANT",                 // לא משלם/לא בתקשורת זמן מה
    NOT_INTERESTED = "NOT_INTERESTED",
    CHURNED = "CHURNED",                 // עזב.ה
    EXEMPT_FROM_PAYMENT = "EXEMPT_FROM_PAYMENT",  // לא לתשלום
    DELETED = "DELETED"
  }
  export enum ProfileCompletionStage {
      REGISTERED = "registered",             // נרשם, אך לא הזין פרטים
      BASIC_INFO = "basic_info",             // הזין שם, ת"ז, אימייל וכו'
      EMPLOYMENT = "employment",             // הזין פרטים תעסוקתיים
      DOCUMENTS = "documents",               // העלה מסמכים נדרשים
      VERIFICATION = "verification",         // נמצא בתהליך אימות
      COMPLETE = "complete"                  // השלים הכל
  }

export class Contact {
    id: number;
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    israeli_id?: string;
    primary_biz_id?: string;
    status?: ContactStatus;
    has_hever?: boolean;
    city?: string;
    street?: string;
    house_number?: string;
    usa_ssn?: string;
    marital_status?: number;
    children_count?: number;
    date_of_birth?: string;
    employment_status?: number | null = null; //PolicyEmploymentStatus
    profile_completion_stage?: ProfileCompletionStage | null = null;
    favorites_rank?: number;
    has_question?: boolean;
    requires_attention?: boolean;
    rev_client?: boolean | null;
    
    lead_source?: string | null = null;
    lead_source_text?: string | null = null;
    last_data_reported_period?: string | null = null;
    last_pre_advice_data_period?: string | null = null;
    message?: string | null = null;
    last_contacted?: Date | null = null;
    next_activity_date?: Date | null = null;
    updated_at?: Date | string | null = null;
  
    data_access_type?: DataAccessTypeEnum;
    share_metadata?: string | ShareMetadata;
    data?: ContactExtData;
    constructor(init?: Partial<Contact>) {
      Object.assign(this, init);
    }
  
    static defaultEmpty(): Contact {
      return new Contact({
        status: ContactStatus.NEW,
      });
    }
  }

  